<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="e-card" style="margin-top: 5px">
      <div
        class="e-card-content"
        style="display: grid; grid-template-columns: repeat(4, 1fr); column-gap: 30px"
      >
        <ejs-datepicker float-label-type="Always" v-model="fromDate"
          placeholder="From Date" format="dd/MM/yyyy"
        />
         <ejs-datepicker float-label-type="Always" v-model="toDate"
          placeholder="To Date" format="dd/MM/yyyy"
        />
        <div class="grid-filter-btn-container">
          <ejs-button type="button" cssClass="e-info grid-filter-btn"
            v-on:click.native="onOkButtonClick" :disabled="isButtonDisabled"
            > View </ejs-button>
        </div>
         <div style="text-align:right">
           <p class="grid-summary-text" v-if='totalApplications'>
            Total Applications: <span class="grid-summary-value"> {{ totalApplications }}</span>
          </p>
        <p class="grid-summary-text" v-if='totalWebUserRequests'>
          Total Web User Requests: <span class="grid-summary-value">{{ totalWebUserRequests }}</span>
        </p>
        <p class="grid-summary-text" v-if='totalGuestUserRequests'>
          Total Guest User Requests: <span class="grid-summary-value">{{ totalGuestUserRequests }}</span>
        </p>
        </div>
        </div>
    </div>
    <div style="margin-top: 5px">
      <ejs-grid
        ref="grid"
        :dataSource="reportData"
        :allowSorting="true"
        :allowPaging="true"
        :allowTextWrap="true"
        :pageSettings="pageSettings"
        :toolbar="toolbarOptions"
        :created="created"
        :toolbarClick="toolbarClick"
        :excelQueryCellInfo="excelQueryCellInfo"
        :allowExcelExport="true"
        height="100%"
        width="100%"
      >
        <e-columns>
          <e-column field="firstName" headerText="First Name" textAlign="Left" width="120"/>
          <e-column field="lastName" headerText="Last Name" textAlign="Left" width="120"/>
          <e-column field="billingAddress" headerText="Billing Address" textAlign="Left" width="200"/>
          <e-column field="city" headerText="City" textAlign="Left" width="120"/>
          <e-column field="province" headerText="Province" textAlign="Left" width="120"/>
          <e-column field="postalCode" headerText="Postal Code" textAlign="Left" width="120"/>
          <e-column field="company" headerText="Company" textAlign="Left" width="200"/>
          <e-column field="requesterEmail" headerText="Requester Email" textAlign="Left" width="200"/>
          <e-column field="municipality" headerText="Municipality" textAlign="Left" width="150"/>
          <e-column field="noOfLocations" headerText="No. of Locations" textAlign="right" width="120"/>
          <e-column field="invoiceNumber" headerText="Invoice No." textAlign="Left" width="120"/>
          <e-column field="invoiceAmount" headerText="Invoice Amount" textAlign="right" width="120"  format="C2"/>
          <e-column field="invoiceDate" headerText="Invoice Date" textAlign="Left" width="130" type="date" :format="gridDateFormat"/>
          <e-column field="datePaid" headerText="Date Paid" textAlign="Left" width="130" type="date" :format="gridDateFormat"/>
          <e-column field="refundedAmount" headerText="Refunded Amount" textAlign="right" width="130"  format="C2"/>
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>

<script>
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import Vue from 'vue';
import {
  GridPlugin,
  Page,
  Toolbar,
  Edit,
  CommandColumn,
  Sort,
  Search,
  ExcelExport,
} from '@syncfusion/ej2-vue-grids';
import { mapGetters } from 'vuex';
import { reportExportFileName } from '@/utils/report-utils';
import { getRptSearchRequestApplications } from '../services/reports-api';
import { getDataGridDateFormat, getExcelReportDate } from '../../../utils/date-utils.js'

Vue.use(DatePickerPlugin);
Vue.use(GridPlugin);

export default {
  name: 'SearchRequestApplications',
  data() {
    return {
      fromDate: null,
      toDate: null,
      reportData: null,
      totalApplications: 0,
      totalWebUserRequests: 0,
      totalGuestUserRequests: 0,
      toolbarOptions: ['Search', 'ExcelExport'],
      pageSettings: { pageSize: 15 },
      gridDateFormat : getDataGridDateFormat(),
    };
  },
  provide: {
    grid: [Page, Edit, Toolbar, CommandColumn, Sort, Search, ExcelExport],
  },
  computed: {
    ...mapGetters({
      loggedUser: 'loggedUser',
    }),
    isButtonDisabled() {
      return !this.fromDate || !this.toDate;
    },
  },
  async created() {
    this.toDate = new Date();
  },
  methods: {
    created() {
      // Added clear button and its functionalities to Searchbar
      if (this.$refs.grid) {
        document
          .getElementById(`${this.$refs.grid.$el.id}_searchbar`)
          .addEventListener('keyup', (e) => {
            this.clearSearchEventListener(e, this.$refs.grid.$el.id);
          });
      }
    },
    clearSearchEventListener(e, gridId) {
      const searchBtnEle = document.getElementById(`${gridId}_searchbutton`);
      const clearBtnEle = searchBtnEle.cloneNode(true);
      clearBtnEle.id = `${gridId}_clearbutton`;
      clearBtnEle.classList.remove('e-search-icon');
      clearBtnEle.classList.add('e-clear-icon');

      clearBtnEle.addEventListener('click', () => {
        e.target.value = '';
        document.getElementById(`${gridId}_clearbutton`).remove();
        searchBtnEle.click();
      });

      if (e.target.value && searchBtnEle.parentNode.childElementCount === 2) {
        searchBtnEle.parentNode.insertBefore(clearBtnEle, searchBtnEle.parentNode.children[1]);
      } else if (!e.target.value || e.target.value === '') {
        document.getElementById(`${gridId}_clearbutton`).remove();
      }
    },
    async onOkButtonClick() {
      const resp = await getRptSearchRequestApplications(this.fromDate, this.toDate);
      this.reportData = resp.data.reportData;
      this.totalApplications = resp.data.totalApplications;
      this.totalWebUserRequests = resp.data.totalWebUserRequests;
      this.totalGuestUserRequests = resp.data.totalGuestUserRequests;
    },
    excelQueryCellInfo(args) {
      switch(args.column.field){
        case 'invoiceDate':
          args.value = getExcelReportDate(args.value);
          break;
        case 'datePaid':
          args.value = getExcelReportDate(args.value);
          break;
      }
    },
    toolbarClick(args) {
      // eslint-disable-next-line default-case
      switch (args.item.text) {
        case 'Excel Export':
          this.$refs.grid.excelExport({
            fileName: reportExportFileName('Search Request Applications.xlsx'),
          });
          break;
      }
    },
  },
};
</script>
<style>
/* ToDo: Refactor; Move shared styles to a seperate file */
.grid-summary-value{
font-weight: 500;
}
p.grid-summary-text {
    margin-top: 5px;
    margin-bottom: 0px;
    padding: 0 20px;
    color: #41637a;
}
.grid-filter-btn-container{
  position: relative;
  min-height: 30px;
}
.grid-filter-btn{
  position: absolute;
  left:0;
  bottom: 7px;
}
.grid-summary-display{
  color: #304b6a;
    border-top: 1px solid #efefef;
}
</style>
